import type { BreakpointType } from '~/types';

export const breakpointList: BreakpointType[] = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
